import type { Prototype } from "../prototype-types";

export const taraRaoPanditPrototypes: Prototype[] = [
  {
    id: "homepage-net-terms-more-prominent",
    name: "Homepage Net Terms More Prominent",
    path: "/trp/homepage-net-terms-more-prominent",
    description:
      "Homepage Net Terms module concept with more prominent messaging.",
    owner: "Tara Rao-Pandit",
    createdAt: "2026-04-10",
    lastUpdated: "2026-04-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/968e4c94fd5f8a36502c6428f89db44abead2b9e417082ffe20b963ebc759876.png",
    creationTool: "cursor",
  },
];
